// extracted by mini-css-extract-plugin
export var attachButton = "_j3-8";
export var sendButton = "_j3-2";
export var sendDisabled = "_j3-4";
export var sendEnabled = "_j3-3";
export var sendIcon = "_j3-6";
export var sendIconDisabled = "_j3-7";
export var sendStreaming = "_j3-5";
export var textarea = "_j3-1";
export var wrapper = "_j3-0";